import { render } from "./TermsOfService-component.vue?vue&type=template&id=20f426f2&scoped=true"
import script from "./TermsOfService-component.vue?vue&type=script&lang=js"
export * from "./TermsOfService-component.vue?vue&type=script&lang=js"

import "./TermsOfService-component.vue?vue&type=style&index=0&id=20f426f2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20f426f2"]])

export default __exports__